export interface DocumentoTipoJSON {
  dt_id: string | null;
  dt_descripcion: string;
  dt_activo: boolean;
}

export class DocumentoTipo {
  protected constructor(private id: string | null, private descripcion: string, private activo: boolean) {}

  static createFrom(id: string | null, descripcion: string, activo: boolean) {
    return new this(id, descripcion, activo);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: DocumentoTipo) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: DocumentoTipoJSON) {
    return DocumentoTipo.createFrom(entity.dt_id, entity.dt_descripcion, entity.dt_activo);
  }

  toJSON(): DocumentoTipoJSON {
    return {
      dt_id: this.getId(),
      dt_descripcion: this.getDescripcion(),
      dt_activo: this.getActivo(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getDescripcion(): string {
    return this.descripcion;
  }

  getActivo(): any {
    return this.activo;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setDescripcion(value: string): void {
    this.descripcion = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }
}
